module.exports = __webpack_public_path__ + "static/media/ic_archive.4fc2012f.svg";